import HomeScorecardCard from "./homeScorecardCard";
import PopUpScorecardFormSupport from "../../../../popUpForms/popUpScorecardFormContact";

const CardScorecardNeedSupport = ({ hoveredTab, onTabHover, onTabLeave }) => {
  return (
    <HomeScorecardCard
      hoveredTab={hoveredTab}
      onTabHover={onTabHover}
      onTabLeave={onTabLeave}
      id="scorecard-contact"
      title="Need Scorecard Support? We can Help!"
      titleColor="var(--orange)"
      popUpComponent={<PopUpScorecardFormSupport />}
      content={[
        {
          type: "header-H5",
          text: "Need assistance with the scorecard?",
          color: "var(--gold)",
        },
        {
          type: "paragraph",
          text: "Schedule a meeting with us, together we can assess the best ways to support you. We offer workshops, webinars, on-the ground pilots, and more.",
          color: "var(--white)",
        },
        {
          type: "paragraph",
          text: 'For more information please visit <a href="/scorecard/faq">Frequently Asked Questions (FAQs)</a> page.',
          color: "var(--shite)",
        },
        { type: "button", color: "var(--orange)", text: "Contact Us" },
      ]}
    />
  );
};

export default CardScorecardNeedSupport;
